<template>
  <VWidget enable-footer-actions content-class="pa-0">
    <template slot="title">{{ $t('title') }}</template>
    <template slot="header-actions">
      <v-btn icon small @click="editAccount">
        <v-icon small>{{ $vuetify.icons.values.edit }}</v-icon>
      </v-btn>
    </template>
    <template slot="content">
      <v-list>
        <v-list-item class="py-1">
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('login') }}</v-list-item-subtitle>
            <v-list-item-title v-if="account">{{ account.login }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <verifiable-field :account="account" field="email" />
        <v-divider />
        <verifiable-field :account="account" field="phone" />
        <v-divider />
        <v-list-item class="py-1">
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('loggedOn') }}</v-list-item-subtitle>
            <v-list-item-title v-if="account" class="grey--text text-body-2">{{
              formatDatetime(account.logged_on)
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template slot="footer-actions">
      <v-btn depressed class="default" @click="editUserPassword">{{ $t('changePassword') }}</v-btn>
    </template>
  </VWidget>
</template>

<script>
import { mapState } from 'vuex'

import { VWidget } from '@argon/app/components'
import { formatDT } from '@argon/app/helpers'
import { NAMESPACE } from '../store'

import VerifyMixin from './VerifyMixin'
import VerifiableField from './VerifiableField'

export default {
  name: 'AccountWidget',
  mixins: [VerifyMixin],
  components: {
    VWidget,
    VerifiableField
  },
  computed: {
    ...mapState(NAMESPACE, ['account'])
  },
  methods: {
    editAccount() {
      this.$router.push({ name: 'editAccount' })
    },
    editUserPassword() {
      this.$router.push({ name: 'editUserPassword' })
    },
    formatDatetime(datetime) {
      return datetime ? formatDT(datetime) : ''
    }
  }
}
</script>

<i18n>
{
  "en": {
    "account": "@:labels.account",
    "changePassword": "Change Password",
    "createdOn": "@:labels.createdOn",
    "edit": "@:labels.edit",
    "loggedOn": "Logged On",
    "login": "@:labels.login",
    "title": "@:labels.account",
    "updatedOn": "@:labels.updatedOn"
  },
  "fr": {
    "account": "@:labels.account",
    "changePassword": "Changer le mot de passe",
    "createdOn": "@:labels.createdOn",
    "edit": "@:labels.edit",
    "loggedOn": "Connecté le",
    "login": "@:labels.login",
    "title": "@:labels.account",
    "updatedOn": "@:labels.updatedOn"
  }
}
</i18n>
